export default __webpack_public_path__ + "static/media/ER12.08698b1c.png";